import {
  IOfferingRes,
  IQuoteOfferingRespSchema,
  IQuoteRespSchema,
  IRateResSchema,
  PriceDisplayEnum,
} from '@monetize/types/app';
import { sortByProductPosition } from '@monetize/utils/core';
import { convertRateResToReq } from '../../utils/rates';
import { PriceDisplaySettingsTable } from './PriceDisplaySettingsTable';

type PriceDisplaySettingsConfigurationProps = {
  isReadOnly?: boolean;
  quoteOffering?: IQuoteOfferingRespSchema | null;
  handleQuoteOfferingUpdate: ({
    priceDisplay,
  }: {
    priceDisplay?: PriceDisplayEnum;
  }) => void;
  offering: IOfferingRes | null;
  offeringRate: IRateResSchema | null;
  quote?: IQuoteRespSchema | null;
  isOfferingLoading: boolean;
};

export const PriceDisplaySettingsConfiguration = ({
  isReadOnly,
  quoteOffering,
  handleQuoteOfferingUpdate,
  offering,
  offeringRate,
  quote,
  isOfferingLoading,
}: PriceDisplaySettingsConfigurationProps) => {
  if (!offering || !offeringRate) {
    return null;
  }
  const sortedProducts = sortByProductPosition(
    offering.offeringProducts.map((product) => ({
      ...product.product,
      isMandatory: product.isMandatory,
      position: product.position,
    })),
  );

  return (
    <PriceDisplaySettingsTable
      isReadOnly={isReadOnly}
      value={quoteOffering?.options?.priceDisplay}
      onChange={(value) => {
        handleQuoteOfferingUpdate({ priceDisplay: value });
      }}
      rate={convertRateResToReq(
        offeringRate,
        offering.products,
        quote?.currency!,
      )}
      quoteOfferingName={quoteOffering?.offeringName || ''}
      products={sortedProducts}
      items={quoteOffering?.items || []}
      isLoading={isOfferingLoading}
    />
  );
};
